import { useState, useEffect } from "react";

// Mirrors ChallengeService::RESEND_COOLDOWN on the server: a new SMS code can only be
// requested once per minute.
const RESEND_COOLDOWN_SECONDS = 60;

const secondsLeftSince = sentAt => {
  if (!sentAt) return 0;

  const elapsedSeconds = (Date.now() - new Date(sentAt).getTime()) / 1000;

  return Math.max(Math.ceil(RESEND_COOLDOWN_SECONDS - elapsedSeconds), 0);
};

// Drives the disabled state and live countdown of the "resend code" control, anchored to
// the moment the code was actually sent (`sentAt`, from the delivery-status poll) rather
// than to render time — so the countdown stays truthful across renders and resends, and
// is inactive while no code has been sent yet.
const useResendCooldown = sentAt => {
  const [secondsLeft, setSecondsLeft] = useState(() => secondsLeftSince(sentAt));

  useEffect(() => {
    setSecondsLeft(secondsLeftSince(sentAt));

    if (!sentAt) return undefined;

    const interval = setInterval(() => {
      setSecondsLeft(secondsLeftSince(sentAt));
    }, 1000);

    return () => clearInterval(interval);
  }, [sentAt]);

  return { secondsLeft, isCoolingDown: secondsLeft > 0 };
};

export default useResendCooldown;
